import { render, staticRenderFns } from "./AppWrapper.vue?vue&type=template&id=a51ad34e&scoped=true&"
import script from "./AppWrapper.vue?vue&type=script&lang=js&"
export * from "./AppWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51ad34e",
  null
  
)

export default component.exports